// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kIyZ","option":"styles_option__1hksR","selected":"styles_selected__1MUM6"};